<template>
  <v-toolbar
    id="header"
    app
    absolute
    clipped-left
    color="white"
    :height="$vuetify.breakpoint.smAndDown ? '64px' : '128px'"
  >
    <div class="v-toolbar__title">
      <!-- Router link for large displays-->
      <fma-header-logo />
    </div>
    <v-spacer />
    <v-btn
      color="secondary"
      text
      flat
      @click="() => $router.push({ name: 'About' })"
    >
      About
    </v-btn>
    <v-btn
      color="secondary"
      text
      flat
      @click="() => $router.push({ name: 'Calendar' })"
    >
      Calendar
    </v-btn>
    <!--
    <v-btn class="secondary--text subheading" flat @click="$router.push({ name: 'About' })">About</v-btn>
    <v-btn class="secondary--text subheading" flat>FAQ</v-btn>
    -->
    <v-spacer />
    <!-- QR code for kiosk mode (always visible) -->
    <div v-if="kioskMode" id="kiosk-qr">
      <qr-code
        text="https://www.ftmeaderesiliency.org/#/categories"
        :size="100"
        color="#000000"
      />
      <div id="kiosk-qr-label" class="secondary--text">
        Take this kiosk with you!
      </div>
    </div>
    <!-- Date and Time for non-kiosk desktop displays -->
    <div v-else id="date-time" class="hidden-md-and-down primary--text">
      <div id="time">
        {{ time.hour }}:{{ time.minutes }} {{ time.timeOfDay }}
      </div>
      <div id="date">
        {{ time.month }} {{ time.day }}<sup>{{ time.ordinalSuffix }}</sup>
        {{ time.year }}
      </div>
    </div>
  </v-toolbar>
</template>

<script>
import FmaHeaderLogo from "@/components/FmaHeaderLogo.vue";
import QrCode from "vue-qrcode-component";
import { mapState } from "vuex";

export default {
  components: {
    FmaHeaderLogo,
    QrCode
  },
  computed: {
    ...mapState({ kioskMode: state => state.kioskMode })
  },
  data() {
    return {
      time: {}
    };
  },
  mounted() {
    this.updateTime();
  },
  methods: {
    updateTime() {
      const months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
      ];
      const getSuffix = function(date) {
        switch (date) {
          case 1:
          case 21:
          case 31:
            return "st";
          case 2:
          case 22:
            return "nd";
          case 3:
          case 23:
            return "rd";
          default:
            return "th";
        }
      };
      const now = new Date();
      this.time = {
        hour: now.getHours() % 12 === 0 ? 12 : now.getHours() % 12,
        minutes:
          now.getMinutes() < 10 ? `0${now.getMinutes()}` : now.getMinutes(),
        timeOfDay: now.getHours() < 12 ? "am" : "pm",
        month: months[now.getMonth()],
        day: now.getDate(),
        ordinalSuffix: getSuffix(now.getDate()),
        year: now.getFullYear()
      };
      setTimeout(this.updateTime, 5000);
    },
    homeButtonTouched() {
      this.$router.push({ name: "Home" });
    }
  }
};
</script>

<style scoped lang="less">
@import "../assets/global.less";

#header {
  white-space: nowrap;
  user-select: none;
  z-index: 10;

  #kiosk-qr {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    #kiosk-qr-label {
      font-size: 11px;
      font-weight: 600;
      letter-spacing: 0.5px;
      text-align: center;
      margin-top: 2px;
    }
  }

  #date-time {
    letter-spacing: -2px;
    text-align: center;
    #date {
      font-size: 32px;
      margin-top: 0px;
    }
    #time {
      font-size: 52px;
      margin-bottom: 0px;
      line-height: 55px;
      text-align: right;
      #meridiem {
        font-size: 32px;
      }
    }
  }
}

// remove underline from link in logo
a {
  text-decoration: none;
}
</style>
